import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { api_getProfile } from '~/backend/api_calls';
import UserSession from '~/backend/user_session';
import { userInfoGTAG4Event } from '~/common/gtag4';

const useTrackGTMUser = () => {
	const { pathname } = useLocation();
	const [gtmUser, setGtmUser] = useState(null);

	useEffect(() => {
		const loadUserData = async () => {
			if (UserSession.isAuthenticated()) {
				try {
					const profile = await api_getProfile();
					if (profile?.id) {
						setGtmUser(profile);
					}
				} catch (err) {
					console.error('Error loading authenticated user profile:', err);
				}
			} else {
				const email = UserSession.getEmail();
				if (email) {
					setGtmUser({ eml: email });
				}
			}
		};

		loadUserData();
	}, []);

	useEffect(() => {
		if (!gtmUser || (!gtmUser.id && !gtmUser.eml)) return;
		userInfoGTAG4Event(gtmUser);
	}, [pathname, gtmUser]);

	return null;
};

export default useTrackGTMUser;
